import { createBrowserRouter } from 'react-router-dom';
import { AppShell } from '@/components/layout/AppShell';
import { ProtectedRoute } from '@/features/auth/ProtectedRoute';
import LoginPage from '@/pages/LoginPage';
import DashboardPage from '@/pages/DashboardPage';
import SkillsListPage from '@/pages/SkillsListPage';
import SkillDetailPage from '@/pages/SkillDetailPage';
import SkillFormPage from '@/pages/SkillFormPage';
import SubagentsListPage from '@/pages/SubagentsListPage';
import SubagentDetailPage from '@/pages/SubagentDetailPage';
import SubagentFormPage from '@/pages/SubagentFormPage';
import ProjectBuilderPage from '@/pages/ProjectBuilderPage';
import UsersPage from '@/pages/UsersPage';
import AuditPage from '@/pages/AuditPage';

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <AppShell />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'skills', element: <SkillsListPage /> },
      { path: 'skills/nova', element: <SkillFormPage /> },
      { path: 'skills/:id', element: <SkillDetailPage /> },
      { path: 'skills/:id/editar', element: <SkillFormPage /> },
      { path: 'subagentes', element: <SubagentsListPage /> },
      { path: 'subagentes/novo', element: <SubagentFormPage /> },
      { path: 'subagentes/:id', element: <SubagentDetailPage /> },
      { path: 'subagentes/:id/editar', element: <SubagentFormPage /> },
      { path: 'projetos', element: <ProjectBuilderPage /> },
      { path: 'usuarios', element: <UsersPage /> },
      {
        path: 'auditoria',
        element: (
          <ProtectedRoute requireRole="admin">
            <AuditPage />
          </ProtectedRoute>
        ),
      },
    ],
  },
  { path: '*', element: <LoginPage /> },
]);
